import React from 'react';
import graphImage from '../../assets/images/graph-chart.jpg';

const TradeChart = () => {
    return (
        <div className="graph-chart">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <img src={graphImage} alt="graph" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TradeChart;
